// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/conditions-generals-hotels/list',
    name: 'conditions-generals-hotels-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/hotels/ConditionGeneral.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_conditions_generals_hotels',
    },
  },
  {
    path: '/conditions-generals-hotels/update',
    name: 'conditions-generals-hotels-update',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/hotels/form/ConditionsGeneral.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_conditions_generals_hotels',
    },
  },
]

export default formTable
